import { HStack, type StackProps } from "@chakra-ui/react";
import React from "react";

type Props = {
  children: React.ReactNode;
} & Pick<StackProps, "mb" | "mt">;

const actionBarProps: StackProps = {
  flexWrap: "wrap",
  justifyContent: "flex-end",
  spacing: 2,
};

export default function EntityProfileActionBar(props: Props) {
  const { children, ...layoutProps } = props;

  return (
    <HStack {...actionBarProps} {...layoutProps}>
      {children}
    </HStack>
  );
}
